export const ORDER_LIST = [
  {
    key: 'score',
    name: 'Más relevante'
  },
  {
    key: 'price_asc',
    name: 'Menor precio'
  },
  {
    key: 'price_desc',
    name: 'Mayor precio'
  },
  {
    key: 'name_asc',
    name: 'Nombre ascendente'
  },
  {
    key: 'name_desc',
    name: 'Nombre descendente'
  }
]
